import PropTypes from 'prop-types';
import React from 'react';

class Overlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mounted: false,
      opacity: 0,
    };
  }

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    style: PropTypes.object,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      if (nextProps.show) {
        this.setState({ mounted: true, opacity: 0 });
        setTimeout(() => {
          this.setState({ opacity: 0.4 });
        }, 0);
      } else {
        this.setState({ opacity: 0 });
        setTimeout(() => {
          this.setState({ mounted: false });
        }, 500);
      }
    }
  }

  render() {
    const { onClick, style = {} } = this.props;
    const { mounted, opacity } = this.state;

    if (!mounted) {
      return null;
    }

    return (
      <div
        onClick={onClick}
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#000',
          opacity,
          transition: `opacity ${this.DURATION}ms`,
          zIndex: 1,
          ...style,
        }}
      />
    );
  }
}

export { Overlay };
